// src/features/players/useVideoPlaylists.ts

import { useMemo } from 'react';
import { usePlaylists } from '@/features/playlists/usePlaylists';
import { LIST_TYPE_LABELS } from '@/lib/constants/playlist';

/**
 * Returns Select-compatible options for video playlists.
 * Used by AdvertisingTab for ad and bumper playlist dropdowns.
 */
export function useVideoPlaylists() {
  const { data, isLoading } = usePlaylists();

  const options = useMemo(() => {
    if (!data) return undefined;

    const all = [...data.customLists, ...data.tagLists];
    return all
      .filter(p => p.mediaType === 'video')
      .map(p => ({
        value: String(p.listId),
        label: `${p.title} (${LIST_TYPE_LABELS[p.listType]})`,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [data]);

  return { options, isLoading };
}
